import React from 'react';
import { Check, X } from 'lucide-react';

const MODULE_LABELS = {
  students: 'Students', staff: 'Staff', attendance: 'Attendance', fees: 'Fees',
  payroll: 'Payroll', exams: 'Exams', library: 'Library', transport: 'Transport',
  hostel: 'Hostel', reception: 'Reception', reports: 'Reports', sms: 'SMS',
  whatsapp: 'WhatsApp', mobile_app: 'Mobile App',
};

export default function PlanFeatureMatrix({ plans = [] }) {
  if (!plans.length) return null;

  const moduleKeys = Object.keys(MODULE_LABELS);

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="border-b">
            <th className="text-left p-3 font-medium">Feature</th>
            {plans.map((p) => (
              <th key={p.id} className="p-3 text-center font-medium min-w-[120px]">
                {p.name}
                {p.is_popular && <span className="block text-xs text-blue-600">Popular</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {moduleKeys.map((key) => (
            <tr key={key} className="border-b border-border/50">
              <td className="p-3 text-muted-foreground">{MODULE_LABELS[key]}</td>
              {plans.map((p) => {
                const enabled = p.features?.modules?.[key];
                return (
                  <td key={p.id} className="p-3 text-center">
                    {enabled ? <Check className="w-4 h-4 text-green-600 mx-auto" /> : <X className="w-4 h-4 text-muted-foreground mx-auto" />}
                  </td>
                );
              })}
            </tr>
          ))}
          <tr className="border-b border-border/50">
            <td className="p-3 text-muted-foreground">Max Students</td>
            {plans.map((p) => (
              <td key={p.id} className="p-3 text-center">{p.features?.limits?.max_students ?? '—'}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}
